import React from "react";
import isEmpty from "lodash/isEmpty";
import { ListItem, SimpleGrid, Text, UnorderedList, VStack } from "@chakra-ui/react";
import Tag from "@/components/tag";
import { TEXT_VARIANTS } from "@/theme/components/text";

type Props = {
  description?: string;
  list?: { label: string; text: string }[];
  title: string;
};

const PlainCard = (props: Props) => {
  const { description, list = [], title } = props;
  const mid = Math.ceil(list.length / 2);
  const list1 = list.slice(0, mid);
  const list2 = list.slice(mid);
  return (
    <VStack
      borderColor={"primary.300"}
      borderRadius={"16px"}
      borderWidth={"1px"}
      className="brand-shadow"
      px={6}
      py={12}
      spacing={6}
    >
      <Tag label={title} />
      {description && (
        <Text
          lineHeight={"1.4"}
          maxW={"900px"}
          textAlign={"center"}
          variant={TEXT_VARIANTS.BODY1}
        >
          {description}
        </Text>
      )}
      {!isEmpty(list) && (
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing={8}
          width={{ base: "100%", lg: "80%" }}
        >
          {[list1, list2].map((list, index) => (
            <UnorderedList key={index} spacing={2}>
              {list.map((item, index) => (
                <ListItem key={index}>
                  <Text
                    as="span"
                    color="text.100"
                    fontWeight={600}
                    variant={TEXT_VARIANTS.BODY2}
                  >
                    {item.label} :{" "}
                  </Text>
                  <Text as="span" color="text.100" variant={TEXT_VARIANTS.BODY2}>
                    {item.text}
                  </Text>
                </ListItem>
              ))}
            </UnorderedList>
          ))}
        </SimpleGrid>
      )}
    </VStack>
  );
};

export default PlainCard;
